import ProductHierarchy from '../models/ProductHierarchy';
import apiClient from '../components/apiClient';

export class ProductHierarchyService {
    static getProductHierarchy() : Promise<ProductHierarchy[]> {
        return apiClient.get<ProductHierarchy[]>(`/ProductHierarchy/GetProductHierarchy`).then(res => res.data);
    }

    static updateProductHierarchy(productHierarchy: ProductHierarchy) : Promise<boolean> {
        return apiClient.put<boolean>(`/ProductHierarchy/UpdateProductHierarchy`, productHierarchy).then(res => res.data);
    }

    static syncSAPProductHierarchy() : Promise<boolean> {
        return apiClient.put<boolean>(`/ProductHierarchy/SyncSAPProductHierarchy`).then(res => res.data);
    }
}